export default {
    name: 'StrUtil',
    // parseAndReplace方法来解析和替换表达式
    parseAndReplace(strWithRegix, obj) {
        if (!strWithRegix || !obj) {
            return strWithRegix;
        }

        // 匹配表达式，但排除包含'data:image'的部分
        const regexPattern = /\{\{([^{}]+)\}\}(?![^<]*base64)/g;
        const matches = strWithRegix.match(regexPattern);

        if (!matches) {
            return strWithRegix; // 没有匹配的表达式，返回原始字符串
        }

        for (const match of matches) {
            const expression = match.slice(2, -2).trim(); // 去掉{{和}}，得到表达式，并去除两边的空格
            const result = this.evalExpression(expression, obj);
            strWithRegix = strWithRegix.replace(match, result);
        }

        return strWithRegix;
    },
    evalExpression(expression, obj) {
        try {
            // 使用函数构造器来创建一个新函数，并执行它
            const func = new Function(...Object.keys(obj), `return ${expression};`);
            return func(...Object.values(obj));
        } catch (error) {
            console.error('Error evaluating expression:', error);
            return undefined;
        }
    },
    /**
     * 首字母小写
     */
    lowerFirst(s) {
        return s && typeof s === 'string' ? s.charAt(0).toLowerCase() + s.slice(1) : s
    },
    /**
     * 首字母大写
     */
    upperFirst(s) {
        return s && typeof s === 'string' ? s.charAt(0).toUpperCase() + s.slice(1) : s
    },
    /**
     * 中间1/3的字符内容加*号
     */
    replaceMiddleThirdWithAsterisks(str) {
        const length = str && str.length || 0;
        if (length < 2) {
            return str
        }
        const start = Math.floor(length / 3);
        const end = Math.ceil(2 * length / 3);
        return str.slice(0, start) + '*'.repeat(end - start) + str.slice(end);
    }
}
